import React, { useContext } from 'react';

import 'normalize.css/normalize.css'
import 'flexboxgrid/css/flexboxgrid.min.css'

import '../../../styles/_estilos_.scss';

import { BarraSuperior } from 'view/section/BarraSuperior/BarraSuperior';
import { Logo } from 'view/component/Logo/Logo';
import { Rodape } from 'view/section/Rodape/Rodape';
import { Menu, MenuContext } from 'view/section/Menu/Menu';


export const TemplatePage: React.FunctionComponent = (props) => {
  const context = useContext(MenuContext);

  const classe = context.compacto ? "menu-compacto" : "";

  return (
    <div id="servicos" className={classe}>
      <Logo />

      <div id="bloco-principal">
        {props.children}
      </div>

      <Menu />

      <BarraSuperior />

      <Rodape />
    </div>
  )
}
